import VideoTpl from "../VideoTpl";
import {
    appendSubView,
    bringViewToFront,
    insertViewAbove, insertViewBelow,
    removeFromSuperView
} from "../../../api/nativeComponent/compVisibleCommon";
import {
    broadcast,
    onBroadcastCustom,
    onBroadcastHideCtaBanner,
    VideoBridgeReadyStatusHasReady
} from "../../../api";
import {_logError, _logSuccess} from "../../../common/m_base/util";
import {onClicked, onPlayerFinish} from "../../../api/nativeComponentListener";
import {checkCreateResOK, checkResOK, getCreatedInstanceId} from "../../../api/apiUtil";
import {webviewFireEvent, webviewLoad} from "../../../api/nativeComponent/compWebview";
import {createPlayerView, playerPause, playerPlay} from "../../../api/nativeComponent/compPlayerView";

export default class VideoTplNative extends VideoTpl {
    constructor(props = {}) {
        super(props);

        this.slotList = [
            {
                isRequired: true,
                campaign: null,
                webViewId: '',
                playerViewId: '',
                playerViewIsPlay: false,
                miniEndcardViewId: '',
                endcardViewId: '',
                webViewRect: {top: 20, right: 10, bottom: 10, left: 20, width: 300, height: 400},
                playerViewRect: {top: 500, right: 100, bottom: 0, left: 150, width: 164, height: 164},
                endcardRect: {top: 20, right: 10, bottom: 10, left: 200, width: 640, height: 360},
                miniECViewRect: {top: 100, right: 100, bottom: 100, left: 50, width: 300, height: 500},
            }
        ]
    }

    async init({JsBridgeRes} = {}) {
        super.init({JsBridgeRes} = {});

        // 初始化上下文
        let SDKContext = await this.initSDKContext()
        SDKContext.broadcastText = '在这里输入要广播的内容'
        window.MTG_RENDER(SDKContext)

        // 设置 webview 半透明
        // await this.translucentView(this.selfViewInstanceId)

        // 创建 playerView
        let slot1 = this.slotList[0]
        this.slot1 = slot1
        slot1.campaign = this.campaignList[0]
        slot1.webViewId = this.selfViewInstanceId
        this.createPlayerView()

        // 预加载 endcard
        this.preloadEndcard();

        // 预加载 miniendcard
        this.preloadMiniEndcard()

        // 注册页面交互(按钮点击)
        this.registerPageEvent()

        VideoBridgeReadyStatusHasReady()
    }

    async show() {
        super.show();

        let unitId = this.unitId

        // 播放完成时展示 endcard
        onPlayerFinish(this.slot1.playerViewId, res => {
            this.hidePlayerView();
            this.hideView()
            this.showEndcardView();

            setTimeout(() => {
                this.showPlayerView();
                this.showView()
            }, 5000)
        })
        // 播放时点击 playerView 暂停, 然后出 miniendcard
        onClicked(this.slot1.playerViewId, async res => {
            console.warn('当前播放的视频被点击了', {res})
            if (this.slot1.playerViewIsPlay) {
                await this.playerPause()
                // await this.appendMiniEndcard();
                this.showEndcardView();
            } else {
                await this.playerPlay()
                await this.removeEndcard();
                // await this.removeMiniEndcard();
            }
        })
        // 开始播放视频
        await this.appendPlayerView()
        await this.playerPlay();
    }

    async showEndcardView() {
        let childCmptId = this.slot1.endcardViewId;
        let parentCmptId = MTG_SDKContext.rootViewInstanceId;
        let endcardAppendOption = {
            parentCmptId,
            childCmptId,
            rect: this.slot1.endcardRect
        }
        console.log('视频播放完成, 开始展示 endcard', {endcardAppendOption})
        await this.append(endcardAppendOption)

        // 触发 webviewshow 事件
        setTimeout(() => {
            console.warn('------------------触发 webviewshow 事件', {parentCmptId, childCmptId, rect: this.slot1.endcardRect})
            this.webviewFireEvent(childCmptId)
        }, 1000)
    }

    webviewFireEvent(id) {
        let unitId = this.unitId
        let parentCmptId = MTG_SDKContext.rootViewInstanceId;
        webviewFireEvent({
            unitId,
            id,
            eventName: 'webviewshow',
            eventData: {parentCmptId, MTG_SDKContext}
        })
    }

    showPlayerView() {
        this.showView(this.slot1.playerViewId)
    }

    hidePlayerView() {
        this.hideView(this.slot1.playerViewId)
    }

    async removeEndcard() {
        let unitId = this.unitId
        await removeFromSuperView({
            unitId,
            id: this.slot1.endcardViewId,
        })
    }

    async removeMiniEndcard() {
        let unitId = this.unitId
        await removeFromSuperView({
            unitId,
            id: this.slot1.miniEndcardViewId,
        })
    }

    async appendMiniEndcard() {
        let unitId = this.unitId
        let parentCmptId = this.slot1.webViewId
        let childCmptId = this.slot1.miniEndcardViewId
        let rect = this.slot1.miniECViewRect
        await appendSubView({unitId, parentCmptId, childCmptId, rect})
        await this.bringViewToFront(childCmptId)

        // 触发 webviewshow
        setTimeout(() => {
            this.webviewFireEvent(childCmptId)
        }, 1000)
    }

    async playerPlay() {
        let unitId = this.unitId
        await playerPlay({unitId, id: this.slot1.playerViewId})
        this.slot1.playerViewIsPlay = true
    }

    async playerPause() {
        let unitId = this.unitId
        await playerPause({unitId, id: this.slot1.playerViewId})
        this.slot1.playerViewIsPlay = false
    }

    registerPageEvent() {
        // 广播
        let customEventName = 'broadcastcustom'
        onBroadcastCustom({
            cb: e => {
                console.log(`${customEventName}触发`, {e})
            }
        })
        onBroadcastHideCtaBanner({
            cb: e => {
                console.log(`${customEventName}触发`, {e})
                this.hideCtaBanner()
            }
        })

        window.mtg_fn_broadcast = (data) => {
            console.log('window.mtg_fn_broadcast = (data) => {')
            broadcast({unitId: this.unitId, eventName: customEventName, data})
        }

        // 其他按钮点击事件
        let slot1 = this.slot1
        // 播放器置顶
        window.mtg_fn_bringPlayerViewToFront = () => {
            let unitId = this.unitId
            let id = slot1.playerViewId
            bringViewToFront({unitId, id})
        }
        // 把 webview 放在播放器上层
        window.mtg_fn_insertPlayerViewAbove = () => {
            let unitId = this.unitId
            let id = slot1.webViewId
            let targetComponentId = slot1.playerViewId
            removeFromSuperView({unitId, id})
            insertViewAbove({unitId, id, targetComponentId})
        }
        // 显示大模板, 隐藏当前模板和 endcard
        window.mtg_fn_bringBTViewToFront = () => {
            let id = MTG_SDKContext.bigTemplateInstanceId
            this.showView(id)
            this.bringViewToFront(id)
            this.hideView()
            this.hideView(slot1.endcardViewId)
            this.hideView(slot1.playerViewId)
        }
        // 显示自己, 隐藏大模板和 endcard
        window.mtg_fn_bringVTViewToFront = () => {
            let id = slot1.webViewId
            this.showView(id)
            this.bringViewToFront(id)
            this.hideView(MTG_SDKContext.bigTemplateInstanceId)
            this.hideView(slot1.endcardViewId)
            this.hideView(slot1.playerViewId)
        }
        // 显示 endcard, 隐藏大模板和播放模板
        window.mtg_fn_bringECViewToFront = () => {

            let id = slot1.endcardViewId
            this.append({parentCmptId: MTG_SDKContext.rootViewInstanceId, childCmptId: id, rect: {
                top: 100,
                left: 100,
                width: 50,
                height: 100,
            }})
            this.showView(id)
            this.bringViewToFront(id)
            // this.hideView()
            // this.hideView(MTG_SDKContext.bigTemplateInstanceId)
        }
        // 显示 miniendcard
        window.mtg_fn_insertMiniECViewAbove = () => {
            this.appendMiniEndcard()
        }
        // 创建并显示一个 cta banner
        window.mtg_fn_showCtaBanner = async () => {
            await this.showCtaBanner()
            // setTimeout(() => {
            //     this.hideCtaBanner()
            // }, 3000)
        }
        // 隐藏 cta banner
        window.mtg_fn_hideCtaBanner = () => {
            this.hideCtaBanner()
        }
        // 隐藏 endcard
        window.mtg_fn_hideEndcard = () => {
            this.hideEndcard()
        }
        // 隐藏 endcard
        window.mtg_fn_hideMiniEndcard = () => {
            this.removeMiniEndcard()
        }
        // 关闭广告
        window.mtg_fn_closeAd = () => {
            this.closeAd()
        }
    }

    async createPlayerView() {
        let unitId = this.unitId
        let slot1 = this.slot1
        let campaign = slot1.campaign
        // 创建 PlayerView
        let mute = this.sdkSetting && this.sdkSetting.playVideoMute
        slot1.playerViewId = getCreatedInstanceId(await createPlayerView({
            unitId,
            campaign,
            mute,
            show_time: 1,
            show_mute: 1,
            show_close: 1,
        }))
    }

    async appendPlayerView() {
        let unitId = this.unitId
        let slot1 = this.slot1

        // 将 playerView 放在 webview 下方
        await insertViewBelow({
            unitId,
            id: slot1.playerViewId,
            targetComponentId: this.selfViewInstanceId,
            rect: slot1.playerViewRect
        })

        // append playerView 到 webview
        // await appendSubView({
        //     unitId,
        //     // parentCmptId: slot1.webViewId,
        //     parentCmptId: MTG_SDKContext.rootViewInstanceId,
        //     childCmptId: slot1.playerViewId,
        //     rect: slot1.playerViewRect
        // })
    }

    async preloadEndcard() {
        let unitId = this.unitId
        let slot1 = this.slot1
        let campaign = slot1.campaign
        let createEndcardRes = await this.createWebview()
        if (checkCreateResOK(createEndcardRes)) {
            slot1.endcardViewId = getCreatedInstanceId(createEndcardRes)
            console.log({endcardViewId: slot1.endcardViewId})
            let campaigns = [campaign]
            let endcardUrl = campaign && campaign.endcard_url
            let filePath = await this.getFilePathByRemoteUrl(endcardUrl)
            let endcardLoadRes = await webviewLoad({
                unitId,
                id: slot1.endcardViewId,
                filePath,
                campaigns,
                rect: slot1.endcardRect
            })
            _logSuccess('endcard 预加载完成', {endcardLoadRes})
            // await this.translucentView(slot1.endcardViewId)
        } else {
            _logError('endcard 预加载失败', {createEndcardRes})
        }
    }

    async hideEndcard() {
        await this.hideView(this.slot1.endcardViewId)
    }

    async preloadMiniEndcard() {
        let unitId = this.unitId
        let slot1 = this.slot1
        let campaign = slot1.campaign
        let createMiniECRes = await this.createWebview()
        if (checkCreateResOK(createMiniECRes)) {
            slot1.miniEndcardViewId = getCreatedInstanceId(createMiniECRes)
            let campaigns = [campaign]
            let miniEndcardUrl = campaign && campaign.rv && campaign.rv.paused_url
            let filePath = await this.getFilePathByRemoteUrl(miniEndcardUrl)
            let webviewLoadRes = await webviewLoad({unitId, id: slot1.miniEndcardViewId, filePath, campaigns})
            if (checkResOK(webviewLoadRes)) {
                _logSuccess('miniendcard 预加载完成', {webviewLoadRes})
                await this.translucentView(slot1.miniEndcardViewId)
                await this.scaleView(slot1.miniEndcardViewId)
            } else {
                _logError('mini endcard webviewLoad 失败', {webviewLoadRes})
            }
        }
    }

    async hideMiniEndcard() {
        await this.hideView(this.slot1.miniEndcardViewId)
    }

    async close() {
        let unitId = this.unitId

        // 先 remove endcard
        await removeFromSuperView({unitId, id: this.slotList[0].endcardViewId})

        // 再 remove 自己和挂在自己身上的 SubView
        await removeFromSuperView({unitId, id: this.slotList[0].webViewId})
    }
}